import * as types from "./types";

export const FoodInitialState = {
  //get request for all food
  foodItems: [],
  foodItemsLoading: false,
  foodItemsError: null,

  // post request
  postFoodLoading: false,
  postFoodError: null,
  
  //get single food
  food:{},
  error:null,
  loading: false,
  
  //foodreport
  foodReportData: null,
};


export const foodReducer = (
  state=FoodInitialState,
  action: any
) => {
  // console.log(state);
  switch (action.type) {
    case types.GET_ALL_FOOD_FETCH_START:
      return {
        ...state,
        foodItemsLoading: true,
      };
    case types.GET_ALL_FOOD_FETCH_SUCCESS:
      // console.log("success");
        // console.log(action.menuItems.data);
      return {
        ...state,
        foodItems: action.foodItems,
        foodItemsLoading: false,
      };

    case types.GET_ALL_FOOD_FETCH_FAILURE:
      return {
        ...state,
        foodItemsError: action.foodItemsError,
        foodItemsLoading: false,
      };

    case types.POST_FOOD_FETCH_START:
      return {
        ...state,
        postFoodLoading: true,
      };
    case types.POST_FOOD_FETCH_SUCCESS:
      return {
        ...state,
        postFoodLoading: false,
        foodItems:[...state.foodItems,action.fooditems]
      };
    case types.POST_FOOD_FETCH_FAILURE:
      return {
        ...state,
        postFoodError: action.postFoodError,
        postFoodLoading: false,
      };
    case types.GET_SINGLE_FOOD_START:
      return{
        ...state,
        loading:true
      };
    case types.GET_SINGLE_FOOD_SUCCESS:
      return{
        ...state,
        loading:false,
        food:action.food,
      }
    case types.GET_SINGLE_FOOD_FAILURE:
      return{
        ...state,
        loading:false,
        error:action.error
      }
      case types.GET_FOOD_REPORT_DATA:
        return {
          ...state,
          foodReportData: action.foodReportData,
        };
    default:
      return state;
  }
};
